import React, { useState } from "react";
import { Link } from "react-router-dom";
import Chat from "../components/Chat";

const Service = () => {
  const [activeTab, setActiveTab] = useState("realEstate");

  const services = {
    realEstate: [
      {
        title: "Premium Residential Estates",
        description:
          "From affordable housing to ultra-luxury private villas, we design and construct beautiful, highly functional homes in Abuja's most sought-after locations.",
        icon: "assets/img/icon/service-icon-2-1.svg",
        image: "/assets/img/sagama01.jpeg",
      },
      {
        title: "Commercial & Corporate Buildings",
        description:
          "We build commanding symbols of corporate success. Our team develops functional, efficient commercial spaces that position your business in the heart of the action, delivered strictly on time and within your budget.",
        icon: "assets/img/icon/service-icon-2-3.svg",
        image: "/assets/img/sagama03.jpeg",
      },
      {
        title: "Land Acquisition & Sales",
        description:
          "We identify prime land opportunities in high-appreciation zones and facilitate seamless acquisition processes for individuals and investors looking to secure their legacy.",
        icon: "assets/img/update1/icon/achive_1_1.svg",
        image: "/assets/img/defult.jpg", // note: file is named defult.jpg
      },
    ],
    heavyEngineering: [
      {
        title: "Roads & Bridges Construction",
        description:
          "Safe, durable, and built to last. Our engineering division utilizes the latest technology to construct roads and bridges that connect communities and withstand the elements.",
        icon: "assets/img/icon/service-icon-2-6.svg",
        image: "/assets/img/tools.png",
      },
      {
        title: "Institutional & Campus Facilities",
        description:
          "We construct state-of-the-art academic buildings, auditoriums, and facilities tailored to the complex needs of universities and colleges.",
        icon: "assets/img/icon/service-icon-2-2.svg",
        image: "/assets/img/Sagama-hero.png",
      },
      {
        title: "Specialized Infrastructure",
        description:
          "From marine environments to high-capacity sports arenas, our certified engineers execute highly specialized structural projects to the strictest international safety standards.",
        icon: "assets/img/icon/service-icon-2-5.svg",
        image: "/assets/img/building.jpg",
      },
    ],
  };

  return (
    <>
      <style>{`
        /* Tabs */
        .services-tabs {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin: 2rem 0 3rem;
          flex-wrap: wrap;
        }
        .services-tabs button {
          padding: 12px 28px;
          border-radius: 50px;
          border: 2px solid #e86b24;
          background: transparent;
          color: #e86b24;
          font-weight: 600;
          font-size: 0.95rem;
          transition: all 0.3s;
          cursor: pointer;
        }
        .services-tabs button.active,
        .services-tabs button:hover {
          background: #e86b24;
          color: #fff;
        }

        /* Card grid */
        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 30px;
          margin-bottom: 3rem;
        }

        /* Service card */
        .service-card-new {
          background: #fff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 8px 25px rgba(0,0,0,0.06);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .service-card-new:hover {
          transform: translateY(-8px);
          box-shadow: 0 18px 45px rgba(0,0,0,0.12);
        }

        .service-card-new .service-img {
          height: 220px;
          background-size: cover;
          background-position: center;
          position: relative;
        }
        /* Subtle gradient overlay for depth */
        .service-card-new .service-img::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50%;
          background: linear-gradient(to top, rgba(0,0,0,0.4), transparent);
        }

        .service-card-new .service-body {
          padding: 25px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
        }

        /* Title with inline orange icon */
        .service-card-new .service-title {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 1rem;
        }
        .service-card-new .service-title img {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          /* turn SVG orange via filter */
          filter: invert(45%) sepia(98%) saturate(1350%) hue-rotate(2deg) brightness(95%) contrast(95%);
        }
        .service-card-new .service-title h3 {
          font-size: 1.2rem;
          font-weight: 600;
          color: #0a1a3d;
          margin: 0;
        }
        .service-card-new p {
          font-size: 0.95rem;
          color: #555;
          line-height: 1.7;
          flex-grow: 1;
        }

        /* Intro */
        .intro-text {
          font-size: 1rem;
          color: #555;
          max-width: 700px;
          margin: 0 auto 1.5rem;
        }

        /* Contact section */
        .contact-section {
          position: relative;
          padding: 5rem 1rem;
          background: url('https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop') center/cover no-repeat;
        }
        .contact-section::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(255,255,255,0.5);
          backdrop-filter: blur(12px);
          z-index: 0;
        }
        .contact-form-card {
          position: relative;
          z-index: 2;
          background: #fff;
          border-radius: 20px;
          padding: 2.5rem 2rem;
          box-shadow: 0 20px 40px rgba(0,0,0,0.12);
          max-width: 500px;
          margin: 0 auto;
          text-align: center;
        }
        .contact-form-card h2 {
          font-size: 1.6rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
          line-height: 1.3;
        }
        .contact-form-card .subtitle-text {
          color: #666;
          margin-bottom: 2rem;
          font-size: 0.9rem;
          line-height: 1.6;
          max-width: 400px;
          margin-left: auto;
          margin-right: auto;
        }
        .form-group {
          position: relative;
          margin-bottom: 1.2rem;
          text-align: left;
        }
        .form-group i {
          position: absolute;
          top: 50%;
          left: 14px;
          transform: translateY(-50%);
          color: #aaa;
          font-size: 0.95rem;
        }
        .form-control {
          width: 100%;
          padding: 12px 18px 12px 42px;
          border: 1px solid #e0e0e0;
          border-radius: 10px;
          font-size: 0.9rem;
          color: #333;
          background: #fafafa;
          transition: border-color 0.3s, box-shadow 0.3s;
        }
        .form-control:focus {
          border-color: #e86b24;
          box-shadow: 0 0 0 3px rgba(232,107,36,0.1);
          outline: none;
        }
        textarea.form-control {
          padding-left: 42px;
          min-height: 100px;
          resize: vertical;
        }
        .th-btn {
          background: #e86b24;
          color: #fff;
          border: none;
          padding: 12px 24px;
          border-radius: 50px;
          font-weight: 600;
          transition: background 0.3s;
          width: 100%;
          font-size: 0.95rem;
          margin-top: 0.5rem;
        }
        .th-btn:hover {
          background: #d2551a;
        }

        @media (max-width: 576px) {
          .contact-form-card {
            padding: 2rem 1.5rem;
          }
        }
      `}</style>

      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">OUR SERVICES</h1>
            <ul className="breadcumb-menu">
              <li><Link to="/">Home</Link></li>
              <li>SERVICES</li>
            </ul>
          </div>
        </div>
      </div>

      <Chat />

      {/* Intro */}
      <section className="space-top">
        <div className="container text-center">
          <h2 style={{ fontSize: '2rem', fontWeight: 700, color: '#0a1a3d' }}>
            Building Premium Lifestyles. Engineering National Infrastructure.
          </h2>
          <p className="intro-text mt-3">
            At Sagama Homes, our capabilities range from developing luxury
            residential estates to constructing complex national infrastructure.
            Our foundation is built on heavy engineering expertise, which means
            every home, office, and road we build is rooted in uncompromising
            structural integrity.
          </p>
        </div>
      </section>

      {/* Tabs */}
      <div className="services-tabs">
        <button
          className={activeTab === "realEstate" ? "active" : ""}
          onClick={() => setActiveTab("realEstate")}
        >
          Real Estate & Property Development
        </button>
        <button
          className={activeTab === "heavyEngineering" ? "active" : ""}
          onClick={() => setActiveTab("heavyEngineering")}
        >
          Heavy Civil Engineering & Infrastructure
        </button>
      </div>

      {/* Service cards */}
      <div className="container">
        <div className="services-grid">
          {services[activeTab].map((service, index) => (
            <div className="service-card-new" key={index}>
              <div
                className="service-img"
                style={{ backgroundImage: `url('${service.image}')` }}
              />
              <div className="service-body">
                <div className="service-title">
                  <img src={service.icon} alt="" />
                  <h3>{service.title}</h3>
                </div>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Redesigned Contact Form */}
      <section className="contact-section" id="contact-sec">
        <div className="contact-form-card">
          <h2>Building Excellence: Where Vision Meets Reality</h2>
          <p className="subtitle-text">
            Tell us about your vision, and we will find or build the exact space that matches your ambition.
          </p>
          <form action="mail.php" method="POST">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <i className="fal fa-user" />
                  <input type="text" className="form-control" name="name" placeholder="Full Name*" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <i className="fal fa-envelope" />
                  <input type="email" className="form-control" name="email" placeholder="Email Address*" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <i className="fal fa-phone" />
                  <input type="tel" className="form-control" name="number" placeholder="Phone Number*" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <select name="subject" className="form-control" style={{ paddingLeft: '42px' }}>
                    <option value="" disabled selected hidden>Select Subject*</option>
                    <option value="Residential Properties">Residential Properties</option>
                    <option value="Commercial Properties">Commercial Properties</option>
                    <option value="Heavy Engineering">Heavy Engineering</option>
                    <option value="General Inquiry">General Inquiry</option>
                  </select>
                  <i className="fal fa-tag" />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <i className="fal fa-pen" style={{ top: '18px' }} />
                  <textarea name="message" className="form-control" placeholder="Your Message*" defaultValue={""} />
                </div>
              </div>
              <div className="col-12">
                <button type="submit" className="th-btn">
                  Send Inquiry <i className="fas fa-long-arrow-right ms-2" />
                </button>
              </div>
            </div>
          </form>
          <div style={{ marginTop: '1.5rem', fontSize: '0.9rem', color: '#555' }}>
            <p>Need immediate help? Call us at <a href="tel:07055558942" style={{ color: '#e86b24', textDecoration: 'none' }}>07055558942</a> or email <a href="mailto:sagamaconstruction125@gmail.com" style={{ color: '#e86b24', textDecoration: 'none' }}>sagamaconstruction125@gmail.com</a> — 24/7 virtual support via email.</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Service;